import { Card, Banner, Button, Collapsible, Divider, FooterHelp, InlineStack, Icon, Layout, Link, Modal, Page, Tabs, Text, BlockStack, Box, InlineGrid, Badge, Select, TextField, SkeletonDisplayText, Tooltip, Checkbox } from '@shopify/polaris';
import React, { useCallback, useEffect, useState, useRef, useContext } from 'react';
import { DI } from '../../../Core';
import { ChevronRightMinor, CircleInformationMajor, MinusMinor, OrdersMajor, PlusMinor, RefreshMajor, TickMinor, UndoMajor } from '@shopify/polaris-icons';
import pricingCheck from '../../../Asests/pricing-images/pricing-tick.png';
import { appBridgeRedirect, appBridgeRouting } from '../Panel/index';
import { Carousel, Switch } from 'antd';
import PlanSkeleton from './skeleton/PlanSkeleton';
import LoadSkeleton from './skeleton/LoadSkeleton';
import './css/styles.css';
import { formatDate, FormatPriceAmount, prepareDiscountedPrice } from './Utilities/Helper';
import CedIQ from '../../../Asests/pricing-images/CedIQ.png';
import Selling from '../../../Asests/pricing-images/Selling.png';
import Shipping from '../../../Asests/pricing-images/Shipping.png';
import { CircleTickIcon, Tick, InfoIcon, DownloadIcon, IndicateIcon } from '../../../Asests/svgIcon/icon';
import { PricingProps, SettlementI, featureModalI, planModalI } from './Utilities/Interfaces';
import PlanCard from './Componant/PlanCard';
import IntroducePricing from '../../../Asests/pricing-images/introducePricing.png';
import CustomCard from '../../Utilities/CustomCard';
import { useMediaQuery } from '../../Utilities/useMediaQuery';
import { useDebounce } from '../useDebounce';
import { disable } from '@shopify/app-bridge/actions/LeaveConfirmation';
const MAX_ORDERS_MONTH = 100000;
const MAX_ORDERS_YEAR = 100000000;
import { useTranslation } from 'react-i18next';
import { RenderHeadersAction } from '../Panel';
import { StoreDispatcher } from "../../../index";
import { hasSelectedLanguage, saveConfigSourceOnly } from '../index';
import { environment } from "../../../environments/environment";
import NewPricingFeb2025 from '../NewPricingFeb2025/NewPricingFeb2025';

const contentStyle: any = {
    carouselProps: {
        slidesToShow: 2.5,
        dots: true,
        arrows: true,
        draggable: true,
        infinite: false,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    infinite: true,
                    dots: true,
                    centerMode: false,
                    centerPadding: '0px',
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: false,
                    centerPadding: '0%',
                    dots: true,
                },
            },
        ],
    },
};

const NewPricingPlan = (props: PricingProps) => {
    const [confirmCheckbox, setConfirmCheckbox] = useState<boolean>(false)
    const dispatcher = useContext(StoreDispatcher);
    const { i18n, t } = useTranslation()
    const [activeModal, setModalActive] = useState<boolean>(false);
    const [selectedLanguage, setSelectedLanguage] = useState('en');
    const carouselRef = useRef<any>(null);
    const [activePlanName, setactivePlanName] = useState<any>('');
    const [activePlanID, setactivePlanID] = useState<string>('');
    const [activeSkeleton, setactiveSkeleton] = useState<boolean>(true);
    const [pendingProcess, setPendingProcess] = useState<any>(undefined);

    const [planLoader, setPlanLoader] = useState<boolean>(true);
    const [flagForceRender, setFlagForceRender] = useState<boolean>(true);
    const isTablet = useMediaQuery("(max-width: 991px)");
    const isMobile = useMediaQuery("(max-width: 768px)");
    const [customPlanDuration, setCustomPlanDuration] = useState<string>("monthly")
    const [customOrdersPerMonth, setCustomOrdersPerMonth] = useState<string>()



    // monthly button states for standardplans
    const [monthlyPlans, setMonthlyPlans] = useState<any>([]);
    const [monthlyButtonPrimary, setMonthlyButtonPrimary] = useState<any>({});
    const [monthlyButtonLoading, setMonthlyButtonLoading] = useState<any>({});

    //yearly button states for standard plans
    const [yearlyPlans, setYearlyPlans] = useState<any>([]);
    const [yearlyButtonPrimary, setYearlyButtonPrimary] = useState<any>({});
    const [yearlyButtonLoading, setYearlyButtonLoading] = useState<any>({});
    const [featureModal, setFeatureModal] = useState<featureModalI>({
        open: false,
        features: []
    })
    const [settlementModal, setSettlementModal] = useState<SettlementI>({
        open: false,
        planId: '',
        data: {}
    });
    const [loadPayButton, setloadPayButton] = useState<boolean>(false);
    const [activePlanData, setActivePlanData] = useState<any>({});
    const [activeButtonIndex, setActiveButtonIndex] = useState<boolean>(false);
    const [monthlyPlusUserFreePlan, setMonthlyPlusUserFreePlan] = useState<any>([]);
    const [freePlan, setFreePlan] = useState<any>({});
    const [trialPlan, setTrialPlan] = useState<any>({});
    const [unlimitedPlan, setUnlimitedPlan] = useState<any>({});
    const [plusUserLoader, setPlusUserLoader] = useState<boolean>(false);
    const [syncActivated, setSyncActivated] = useState<boolean>(true);
    const [planModal, setPlanModal] = useState<planModalI>({
        active: false,
        plan_data: {}
    });
    const [currentPlanModal, setCurrentPlanModal] = useState<planModalI>({
        active: false,
        plan_data: {}
    });
    const [expanded, setExpanded] = useState<boolean>(false);

    // plan-type tab switcher state
    const [selected, setSelected] = useState<number>(0);
    // FAQ State
    const [faq, setFaq] = useState<any>([]);

    // useEffect(() => {
    //     if (props?.redux?.language) {
    //         setSelectedLanguage(props?.redux?.language ?? "en");
    //         return;
    //     }
    //     else {
    //         props.di.POST('connector/config/getConfig', {
    //             "group_code": ["language"]
    //         }).then((response: any) => {
    //             if (response?.success) {
    //                 if (hasSelectedLanguage(response, "language", "selectedLanguage")) {
    //                     dispatcher({
    //                         type: 'update_language',
    //                         state: {
    //                             language: response?.data?.[0]?.value?.selectedLanguage ?? 'en',
    //                         },
    //                     });
    //                     props?.di?.globalState?.set('language', response?.data?.[0]?.value?.selectedLanguage ?? 'en');
    //                     i18n.changeLanguage(response?.data?.[0]?.value?.selectedLanguage ?? 'en');
    //                 }
    //                 else {
    //                     setModalActive(true);
    //                 }
    //             } else {
    //                 props.error(t(response.message));
    //             }
    //         });
    //     }
    // }, []);

    const fetchLanguageConfig = async () => {
        const url = `${environment.API_ENDPOINT}connector/config/getConfig`;
        const requestHeaders = new Headers();
        const auth: any = props.di.globalState.getBearerToken();

        // Set headers
        requestHeaders.set('Authorization', auth);
        requestHeaders.set('appCode', "eyJzaG9waWZ5IjoiYW1hem9uX3NhbGVzX2NoYW5uZWwiLCJhbWF6b24iOiJhbWF6b24ifQ==");
        requestHeaders.set('appTag', "amazon_sales_channel");
        requestHeaders.set('Content-Security-Policy', "frame-ancestors https://admin.shopify.com");
        requestHeaders.set('Ced-Source-Id', props.di.globalState.get('source_id') ?? '');
        requestHeaders.set('Ced-Source-Name', "shopify");
        // requestHeaders.set('ced-target-name', "amazon");
        requestHeaders.set('Content-Type', 'application/json');

        const requestBody = JSON.stringify({ group_code: ["language"] });

        try {
            const response = await fetch(url, {
                headers: requestHeaders,
                method: 'POST',
                body: requestBody,
            });
            const data = await response.json();

            if (data?.success) {
                return data;
            } else {
                throw new Error(data?.message || "Failed to fetch language settings.");
            }
        } catch (error) {
            console.error("Language API Error:", error);
            throw new Error("An error occurred while fetching language settings.");
        }
    };

    useEffect(() => {
        const initializeLanguage = async () => {
            if (props?.redux?.language) {
                setSelectedLanguage(props?.redux?.language ?? "en");
                return; // If language is already set in redux, no need to fetch again
            }

            try {
                const response = await fetchLanguageConfig(); // Use custom function for "language" group
                const selectedLanguage = response?.data?.[0]?.value?.selectedLanguage || "en";

                if (hasSelectedLanguage(response, "language", "selectedLanguage")) {
                    dispatcher({
                        type: 'update_language',
                        state: { language: selectedLanguage },
                    });
                    props?.di?.globalState?.set('language', selectedLanguage);
                    i18n.changeLanguage(selectedLanguage);
                } else {
                    setModalActive(true); // Show language selection modal
                }
            } catch (error) {
                console.error("Language API Error:", error);
                props.error(t("An error occurred while fetching language settings."));
            }
        };

        initializeLanguage(); // Initialize language logic
    }, []);


    useEffect(() => {
        getActive()
        getFaq()
        if (props?.location?.state !== null && Object.values(props?.location?.state)?.length > 0) {
            if (props?.location?.state?.category === 'regular') {
                setSelected(0)
                getAll('regular')
            }
            else if (props?.location?.state?.category === 'marketing') {
                // setSelected(1)
                getAll('regular')
                // getAll('marketing')
            }
            else {
                getAll('regular')
                setSelected(0)
            }
            if (props?.location?.state?.billed_type === 'monthly') setActiveButtonIndex(false)
            else if (props?.location?.state?.billed_type === 'yearly') setActiveButtonIndex(true)
        }
        else {
            setActiveButtonIndex(false)
            setSelected(0)
            getAll('regular')
        };
    }, [flagForceRender])

    // function to toggle b/w regular and marketting plans
    const handleTabChange = useCallback((selectedTabIndex: number) => {
        setActiveButtonIndex(false)
        setSelected(selectedTabIndex)
        setFreePlan({})
        selectedTabIndex == 0 ? getAll('regular') : getAll('marketing')
    }, []);

    // api call to get all standard plans
    const getAll = (planType?: string) => {
        let obj: any = {};
        let monthlyPlan: any = [];
        let yearlyPlan: any = [];
        let monthlyFreePlusUser: any = [];
        let monthlyTrialPlusUser: any = [];
        setPlanLoader(true)

        obj['category'] = planType ? planType : selected === 1 ? "marketing" : "regular"
        props.di.GET('plan/plan/get', obj).then((data: any) => {
            if (data.success) {
                let allPlan = data?.data?.data?.rows;

                Object.keys(allPlan)?.forEach((plan: any) => {
                    if (plan?.toLowerCase() === "free") {
                        setFreePlan({ ...allPlan['free'] })
                    }
                    if (plan === "trial") {
                        setTrialPlan({ ...allPlan['trial'] })
                    }
                    if (plan === "unlimited") {
                        setUnlimitedPlan({ ...allPlan['unlimited'] })
                    }
                    else {
                        allPlan?.[plan]?.monthly && monthlyPlan.push(allPlan?.[plan]?.monthly);
                        allPlan?.[plan]?.yearly && yearlyPlan.push(allPlan?.[plan]?.yearly);
                    }
                })
                if (props?.redux?.current?.source?.plan_name == 'shopify_plus') {


                    setMonthlyPlans([...monthlyPlan?.filter((plan: any) => {
                        if (plan?.title?.toLowerCase() == t('free')) {
                            monthlyFreePlusUser.push(plan)
                        } else if (plan?.title == 'Trial') {
                            monthlyTrialPlusUser.push(plan)
                        }
                        return (plan?.title !== 'Free' && plan?.title !== "Trial")
                    })])
                    setYearlyPlans([...yearlyPlan?.filter((plan: any) => {
                        return (plan?.title !== 'Free' && plan?.title !== "Trial")
                    })])
                } else {

                    setMonthlyPlans([...monthlyPlan.filter((plan: any) => plan?.title !== "Trial")]);
                    setYearlyPlans([...yearlyPlan]);
                }

                let tempMonthlyObj: any = {};
                let tempYearlyObj: any = {};

                monthlyPlan?.forEach((plan: any) => tempMonthlyObj[plan?.plan_id] = false)
                yearlyPlan?.forEach((plan: any) => tempYearlyObj[plan?.plan_id] = false)

                setMonthlyButtonLoading({ ...tempMonthlyObj });
                setMonthlyButtonPrimary({ ...tempMonthlyObj });

                setYearlyButtonLoading({ ...tempYearlyObj });
                setYearlyButtonPrimary({ ...tempYearlyObj });

                monthlyFreePlusUser?.length !== 0 && setMonthlyPlusUserFreePlan([...monthlyFreePlusUser])

            }
            else props.error(t(data.message));
            setPlanLoader(false);
        });
    };




    useEffect(() => {
        let obj: any = {};
        if (selected === 1) {
            obj['category'] = "regular"
            props.di.GET('plan/plan/get', obj).then((data: any) => {
                if (data.success) {
                    let allPlan = data?.data?.data?.rows;
                    Object.keys(allPlan)?.forEach((plan: any) => {
                        if (plan === "unlimited") {
                            setUnlimitedPlan({ ...allPlan?.['unlimited'] })
                        }
                    })

                }


            })

        }
    }, [selected])




    // api call for active plan
    const getActive = () => {
        props.di.GET('plan/plan/getActive').then((data: any) => {
            setactiveSkeleton(false)
            setPendingProcess(data?.data?.pending_processes && data?.data?.pending_processes?.length > 0 ? data?.data?.pending_processes : undefined)
            if (data.success) {
                setactivePlanName(data?.data?.active_plan?.plan_details?.title);
                setActivePlanData(data?.data)
                setactivePlanID(data?.data?.active_plan?.plan_details?.plan_id)
                if (data?.data?.settlement_info && Object?.values(data?.data?.settlement_info)?.length > 0 && !data?.data?.user_service?.postpaid?.is_capped) {
                    props.di.globalState.set('isPlanExpired', JSON.stringify({}))
                    props.di.globalState.set('isSettlementGenerated', JSON.stringify(data?.data?.settlement_info))
                    props.checkPlanExpiration();
                }
                else {
                    props.di.globalState.removeLocalStorage('isSettlementGenerated')
                    props.di.globalState.set('isPlanExpired', JSON.stringify({}))
                    props.checkPlanExpiration()
                }
                if (data?.data?.sync_activated === false) {
                    setSyncActivated(false)
                    // if (+data?.data?.user_service?.prepaid?.service_credits == 50) {
                    //     props.error(data?.message, { content: '', onAction: () => { } }, 12000);
                    //     props.di.globalState.set('is_plan_active', 'open_plan')
                    //     props.updatePlanStatus('_PENDING_');
                    // }
                    // else

                    if (data?.data?.settlement_info && data?.data?.settlement_info?.invoice && Object.keys(data?.data?.settlement_info?.invoice)?.length > 0 ) {

                        props.error(t(data?.message), { content: '', onAction: () => { } }, 12000);
                        props.di.globalState.set('is_plan_active', 'open_plan')
                        props.updatePlanStatus('_PENDING_');
                    }
                    else {
                        props.di.globalState.set('is_plan_active', 'true');
                        props.updatePlanStatus('_DONE_');
                    }
                } else {
                    setSyncActivated(true)
                    props.di.globalState.set('is_plan_active', 'true')
                    props.updatePlanStatus('_DONE_')
                }
            }
            else {
                setactivePlanName('')
                setactivePlanID('')
            }
            setactiveSkeleton(false);
        });
    }

    // api to Choose plan
    const choosePlan = (planId: any, planName?: string) => {
        let monthlyTemp = { ...monthlyButtonLoading };
        let yearlyTemp = { ...yearlyButtonLoading };

        monthlyTemp[planId] = true;
        yearlyTemp[planId] = true;
        setMonthlyButtonLoading({ ...monthlyTemp });
        setYearlyButtonLoading({ ...yearlyTemp });

        props.di.GET('plan/plan/choose', { plan_id: planId })
            .then((data: any) => {
                if (data?.hasOwnProperty('can_proceed_import') && !data?.can_proceed_import) {
                    props.di.globalState.set('plan', JSON.stringify({
                        plan_name: planName,
                        plan_id: planId
                    }))
                    props.importValidation()
                }
                if (data.success) {
                    if (data?.data?.confirmation_url) {
                        let tempUrl = data?.data?.confirmation_url;
                        props.di.globalState.removeLocalStorage(`is_plan_active`)
                        if (process.env.REACT_APP_PROD === "1") {
                            appBridgeRedirect(tempUrl, props);
                        }
                        else window.open(tempUrl)
                    }
                    else {
                        props.di.globalState.removeLocalStorage(`is_plan_active`)
                        props.history("./home")
                        // props.planIsActive();
                    }

                    if (planName == 'Trial') {
                        props.di.globalState.set(`trial_plan_active`, data?.message);
                        appBridgeRouting("dashboard", props)
                    }

                    if (planName == 'Free') {
                        props.success(t(data?.message))
                        setFlagForceRender(!flagForceRender)
                    }

                    setPlanModal({ active: false, plan_data: {} })
                }
                else props.error(t(data?.message));

                monthlyTemp[planId] = false;
                yearlyTemp[planId] = false;
                setMonthlyButtonLoading({ ...monthlyTemp });
                setYearlyButtonLoading({ ...yearlyTemp });
            });
    }

    //api call to to get faq of pricing section
    const getFaq = () => {
        let temp: any = {};
        let tempFaq: any[] = [];
        props.di.POST('webapi/rest/v1/faq/search', {
            "marketplace": "amazon_sales_channel",
            "limit": 6,
            'group': 'Pricing Plan'
        }).then((data: any) => {
            if (data?.success) {
                data?.data?.['amazon_sales_channel']?.['Pricing Plan']?.data?.forEach((data: any) => {
                    temp = {
                        id: data?.['_id'],
                        show: false,
                        question: data?.title,
                        answer: data?.answer
                    }
                    tempFaq?.push(temp);
                })
                setFaq(tempFaq)
            }
        })
    }

    // function to toggle between monthly and yearly
    const handleButtonClick = useCallback((index: boolean) => {
        if (activeButtonIndex === index) return;
        setActiveButtonIndex(index);
        carouselRef.current.goTo(0);
    }, [activeButtonIndex]);

    // function to render faq
    const renderFaq = (faq_sections: any) => {
        return (
            <BlockStack gap="500">
                {Object.keys(faq_sections).map((key: any, ind: number) => {
                    return (
                        <Card roundedAbove='sm' key={ind}>
                            <div onClick={() => {
                                const temp: any = [...faq_sections];
                                temp[key]['show'] = !temp[key]['show'];
                                setFaq(temp);
                                closeFaq(key);
                            }}
                            >
                                <InlineStack align="space-between" wrap={false}>
                                    <Text as='p' fontWeight="semibold"> {t(faq_sections?.[key]?.['question'])} </Text>
                                    <Button variant='plain' icon={faq_sections?.[key]?.['show'] ? MinusMinor : PlusMinor} />
                                </InlineStack>
                                <Collapsible
                                    open={faq_sections?.[key]?.['show']}
                                    id="basic-collapsible"
                                    transition={{ duration: '500ms', timingFunction: 'ease-in-out' }}
                                    expandOnPrint
                                >
                                    <Text as='p' tone="subdued"> {t(faq_sections?.[key]?.['answer'])} </Text>
                                </Collapsible>
                            </div>
                        </Card>
                    );
                })}
            </BlockStack>
        );
    };

    // function to close the open faq
    const closeFaq = (key: any) => {
        faq?.forEach((value: any, id: any) => {
            if (id != key) {
                const temp = [...faq];
                temp[id]['show'] = false;
                setFaq(temp);
            }
        });
    };



    const CustomPlanCard = () => {
        return (
            <div className='Custom-Pricing--Card Custom__enterprice-card--height'>
                <Card roundedAbove='sm'>
                    <div className='Custom-Alpha-Card__Section'>
                        <BlockStack gap="800">
                            <Text as='p' tone='success' alignment='center'>{t("ENTERPRISE")}</Text>
                            <BlockStack gap="100" inlineAlign='center'>
                                <Text as='p' fontWeight='semibold'>{t("Custom Solutions")}</Text>
                                <Text as='p' fontWeight='semibold'>{t("for High-volume Merchants")}</Text>
                            </BlockStack>
                            <Divider />
                            <Text as='p' alignment='center'>{t("Don't settle for a one-size-fits-all solution when you can have a custom plan built exclusively for your business. Reach out to us today and let us help you take your business to the next level of success. Together, we'll find the perfect solution to meet your unique needs.")}</Text>
                            <Button
                                fullWidth
                                size='large'
                                onClick={() => {
                                    if (activePlanName == '') props.history('../panel/support', { replace: false, state: { fromPricingPlan: true } })
                                    else props.history('../support')
                                }}>
                                {t("Contact Now")}
                            </Button>
                        </BlockStack>
                    </div>
                </Card>
            </div>
        );
    }

    const handlePlanModal = (plan_data: any) => {
        setPlanModal({ active: true, plan_data: plan_data })
    }

    // rendering plans and add-ons
    const renderPlans = () => {
        let renderContent: React.ReactNode[] = [];
        renderContent.push(
            <div className="custom-carousel Custom--Pricing-Slider-Dot Custom--Pricing-arrow">
                <Carousel
                    ref={carouselRef}
                    {...contentStyle.carouselProps}
                    afterChange={(currentSlide: any) => { }}
                >
                    {
                        planLoader ? PlanSkeleton() :
                            (activeButtonIndex ? yearlyPlans : monthlyPlans)?.map((plan: any, index: number) => {
                                return <PlanCard
                                    key={index}
                                    type={activeButtonIndex ? 'yearly' : 'monthly'}
                                    plan={plan}
                                    activePlanName={activePlanName}
                                    activePlanData={activePlanData}
                                    activePlanID={activePlanID}
                                    setFeatureModal={setFeatureModal}
                                    buttonPrimary={activeButtonIndex ? yearlyButtonPrimary : monthlyButtonPrimary}
                                    setButtonPrimary={activeButtonIndex ? setYearlyButtonPrimary : setMonthlyButtonPrimary}
                                    buttonLoading={activeButtonIndex ? yearlyButtonLoading : monthlyButtonLoading}
                                    setSettlementModal={setSettlementModal}
                                    handlePlanModal={handlePlanModal}
                                />
                            })
                    }
                    {!planLoader && CustomPlanCard()}
                </Carousel>
            </div>
        )
        return renderContent;
    }

    // api call to pay settlement amount
    const settleServices = () => {
        setloadPayButton(true);
        props.di.GET('plan/plan/settleServices', {
            amount: activePlanData?.settlement_info?.settlement_price,
            type: 'onetime',
        })
            .then((data: any) => {
                if (data.success) {
                    let tempUrl = data?.data?.confirmation_url ?? '';

                    if (data.message == 'Capped amount already set.') {
                        props.error(t(data?.message));
                        setloadPayButton(false);
                    } else if (process.env.REACT_APP_PROD === "1") {
                        appBridgeRedirect(tempUrl, props);
                    } else {
                        window.open(tempUrl);
                    }
                } else {
                    props.error(t(data?.message));
                }
                setloadPayButton(false);
            });
    }

    // tab switch for regular and marketing plans
    const tabs = [
        {
            id: 'regular',
            content: t('Regular Plans'),
            subcontent: renderPlans(),
        },
        // {
        //     id: 'marketing',
        //     content: 'Marketing Plans',
        //     disabled: true,
        //     subcontent: renderPlans(),
        // },
    ];


    const renderButton = () => {
        const handleButtonClick = () => {
            setPlanModal({ active: true, plan_data: trialPlan?.monthly });
        };
        // const handleButtonClickFree = () => {
        //     setPlanModal({ active: true, plan_data: activeButtonIndex ? freePlan?.yearly : freePlan?.monthly });

        // };
        // const isFreePlanAvailable = Object.keys(freePlan)?.length !== 0;

        const isTrialPlanAvailable = Object.keys(trialPlan)?.length !== 0;
        const button_disable = isTrialPlanAvailable
            ? trialPlan?.monthly?.hasOwnProperty("active")
                ? trialPlan?.monthly?.active === false
                    ? true
                    : true
                : false
            : true;
        const message = isTrialPlanAvailable ? trialPlan?.monthly?.hasOwnProperty("message") ? trialPlan?.monthly?.message : false : false
        const button = (
            <BlockStack>
                <Button
                    disabled={!isTrialPlanAvailable || button_disable}
                    onClick={handleButtonClick}
                    variant="primary">
                    {t("Claim your free trial")}
                </Button>
                <Text tone='subdued' alignment='center' as='p'>{t("Available only once")}</Text>


            </BlockStack>
        )
        const freePlanButton = (
            <div className='Custom__Button--FreePlan'>
                {message ? <Tooltip content={t(trialPlan?.monthly?.message)}>
                    {button}</Tooltip> : button}
            </div>
        );


        if (activePlanName == "Trial") {
            return activePlanName == "Trial" && activePlanName ?
                message ? <Tooltip content={t(trialPlan?.monthly?.message)}>
                    {button}
                </Tooltip> :
                    button
                : freePlanButton;
        }

        if (activePlanName !== "Trial") {
            return activePlanName !== "Trial" && activePlanName ? message ? <Tooltip content={t(trialPlan?.monthly?.message)}>
                {button}
            </Tooltip> : (
                button
            ) : freePlanButton;
        }

        return freePlanButton;
    };

    const handleChange = (value: string) => {
        setLoading(true)
        // Remove any non-digit characters
        const onlyDigits = value.replace(/\D/g, '');
        // Set the state with the cleaned value
        setCustomOrdersPerMonth(onlyDigits);
        if (onlyDigits == "") {
            setCustomPrice({})

        }
    };

    const [customPrice, setCustomPrice] = useState<any>({})
    const [loading, setLoading] = useState<boolean>(false)



    const debounceCustomOrders = useDebounce(customOrdersPerMonth, 1000);
    const debounceCustomPlanDuration = useDebounce(customPlanDuration, 1000);

    const chooseCustomPlan = (data: any) => {
        if (process.env.REACT_APP_PROD === "1") {
            appBridgeRedirect(data?.payment_link, props);
        } else {
            window.open(data?.payment_link);
        }


    }

    const customplanAPIcall = (payload: any) => {
        props.di.GET("plan/plan/processCustomUserPlan", payload).then((data: any) => {
            setLoading(false)
            if (data?.success) {
                if (data?.data) {
                    setCustomPrice(data?.data)
                } else if (data?.payment_link) {
                    chooseCustomPlan(data)
                }

            } else {
                props.error(t(data?.message) || t("something went wrong"))

            }
            return data

        })

    }

    useEffect(() => {
        if (parseInt(customOrdersPerMonth || "0") > 0) {
            const payload = {
                service_credits: customOrdersPerMonth,
                billed_type: customPlanDuration,
                get: 1
            }
            customplanAPIcall(payload)
        }

    }, [debounceCustomOrders, debounceCustomPlanDuration])

    const handleResetButton = () => {
        setCustomPrice({})
        setCustomOrdersPerMonth(undefined)
        setCustomPlanDuration("monthly")
    }

    const handleCustomPlan = () => {
        // handlePlanModal(customPrice)
        const payload = {
            service_credits: customOrdersPerMonth,
            billed_type: customPlanDuration,
        }
        customplanAPIcall(payload)

    }


    const getCustomPrice = () => {
        if (customPrice && Object.keys(customPrice)?.length > 0) {
            if (customPrice?.discounts?.[0]?.type == 'percentage') {
                return FormatPriceAmount(((customPrice?.custom_price - ((customPrice?.discounts[0]?.value / 100) * customPrice?.custom_price))?.toString()))

            }
            else if (customPrice?.discounts[0]?.type == 'fixed') {
                return FormatPriceAmount((customPrice?.custom_price - customPrice?.discounts?.[0]?.value)?.toString())

            } else {
                return FormatPriceAmount((customPrice?.custom_price)?.toString())

            }

        } else {
            return FormatPriceAmount("0");
        }

    }

    const handleClose = async () => {
        // props.di.POST('connector/config/saveConfig', {
        //     "data": [
        //         {
        //             "data": {
        //                 selectedLanguage: "en"
        //             },
        //             "group_code": "language"
        //         }
        //     ]
        // }).then((response: any) => {
        //     if (response.success) {
        //         i18n.changeLanguage("en");
        //         props.di.globalState.set('language', "en");
        //         dispatcher({
        //             type: 'update_language',
        //             state: {
        //                 language: "en",
        //             },
        //         });
        //     } else {
        //         props.error(t(response.message))
        //     }
        //     setModalActive(false);
        // });


        let response = await saveConfigSourceOnly("language", "en", props);
        if (response.success) {
            i18n.changeLanguage("en");
            props.di.globalState.set('language', "en");
            dispatcher({
                type: 'update_language',
                state: {
                    language: "en",
                },
            });
        } else {
            props.error(t(response.message))
        }
        setModalActive(false);
    }

    const handleLanguageChange = async () => {
        // props.di.POST('connector/config/saveConfig', {
        //     "data": [
        //         {
        //             "data": {
        //                 selectedLanguage: selectedLanguage
        //             },
        //             "group_code": "language"
        //         }
        //     ]
        // }).then((response: any) => {
        //     if (response.success) {
        //         i18n.changeLanguage(selectedLanguage);
        //         props.di.globalState.set('language', selectedLanguage);
        //         dispatcher({
        //             type: 'update_language',
        //             state: {
        //                 language: selectedLanguage ?? 'en',
        //             },
        //         });
        //     } else {
        //         props.error(t(response.message))
        //     }
        //     setModalActive(false);
        // });

        let response = await saveConfigSourceOnly("language", selectedLanguage, props);
        if (response.success) {
            i18n.changeLanguage(selectedLanguage);
            props.di.globalState.set('language', selectedLanguage);
            dispatcher({
                type: 'update_language',
                state: {
                    language: selectedLanguage ?? 'en',
                },
            });
        } else {
            props.error(t(response.message))
        }
        setModalActive(false);
    }

    const languages = [
        { label: 'English(default)', value: 'en' },
        { label: 'हिंदी', value: 'hn' },
        { label: 'Deutsch', value: 'gr' },
        { label: 'Français', value: 'fr' },
        { label: 'Español', value: 'sp' },
    ];

    // Usage
    return <NewPricingFeb2025 {...props} />
    // return (
    //     <div className='card-box-shadow'>
    //         {
    //             activeSkeleton ? LoadSkeleton()
    //                 :
    //                 <div className='Custom-Page--Align'>

    //                     <Page
    //                         backAction={activePlanName && activePlanName != "" ? {
    //                             content: "Subscription Plan",
    //                             onAction: () => props.history('../home'),
    //                         } : undefined}
    //                         title={t("Pricing Plans")}
    //                         subtitle={t("Enjoy flexible pricing plans to fit your scale with monthly, yearly and custom pricing options available.")}
    //                         primaryAction={
    //                             <RenderHeadersAction {...props} show_only_lng_switcher />
    //                         }
    //                     >

    //                         <Modal
    //                             open={activeModal}
    //                             onClose={() => { }}
    //                             title={t("Preferred Language of the App")}
    //                         >
    //                             <Modal.Section>
    //                                 <BlockStack gap="200">
    //                                     <Text as="p" variant="bodyMd">
    //                                         {t("Before getting started, please select the preferred language for the app")}
    //                                     </Text>
    //                                     <Select
    //                                         label=""
    //                                         labelHidden
    //                                         options={languages}
    //                                         onChange={(e) => setSelectedLanguage(e)}
    //                                         value={selectedLanguage}
    //                                     />
    //                                     {<div className='Custom__Sync--Update'>
    //                                         <Checkbox
    //                                             // disabled={selectedLanguage === "en"}
    //                                             checked={confirmCheckbox}
    //                                             onChange={(e) => setConfirmCheckbox(e)}
    //                                             label={<Text variant="bodySm" tone="subdued" as="p">
    //                                                 {t("You have chosen")} <Text as="span" fontWeight="bold">{languages.filter((language: any) => language.value == selectedLanguage)?.[0]?.label}</Text> {t("as your preferred language. You can change it later in the Settings section.")}
    //                                             </Text>}
    //                                         />
    //                                     </div>}
    //                                     <Button
    //                                         variant='primary'
    //                                         disabled={!confirmCheckbox}
    //                                         onClick={handleLanguageChange}
    //                                     >
    //                                         {t("Click to Proceed")}
    //                                     </Button>
    //                                 </BlockStack>
    //                             </Modal.Section>
    //                         </Modal>

    //                         <BlockStack gap='1600'>
    //                             <BlockStack gap="1000">
    //                                 {pendingProcess && <InlineStack align='start' >
    //                                     <Card background='bg-fill-info-secondary'>
    //                                         <InlineStack gap='100' align='space-between' >
    //                                             <Icon
    //                                                 source={InfoIcon}
    //                                                 tone="base"
    //                                             />
    //                                             <BlockStack>

    //                                                 <Text as='h2' fontWeight='bold'>{t("Payment is in progress")}</Text>
    //                                                 <Text as='p'>

    //                                                     {t("Your payment is currently being processed. You will be notified once it is successful.")}

    //                                                 </Text>
    //                                             </BlockStack>
    //                                         </InlineStack>
    //                                     </Card>
    //                                 </InlineStack>}
    //                                 <Box padding={{ xs: '400' }}>
    //                                     <BlockStack gap="300">
    //                                         <InlineStack gap="200" align='space-between' blockAlign='stretch' >
    //                                             <InlineStack gap="200" align='start' blockAlign='center' wrap={false}>
    //                                                 <Text as='p'>{t("Monthly")}</Text>
    //                                                 <div className='Custom__plan-switcher'>
    //                                                     <Switch
    //                                                         checked={activeButtonIndex}
    //                                                         onChange={handleButtonClick}
    //                                                     />
    //                                                 </div>
    //                                                 <InlineStack gap="100">
    //                                                     <Text as='span' tone='subdued'>{t("Pay annually to")} </Text>
    //                                                     <Badge tone="info">{t("Get 1 month FREE subscription")}</Badge>
    //                                                     {/* <Text as='span' tone='critical' fontWeight='semibold'></Text> */}
    //                                                 </InlineStack>
    //                                             </InlineStack>
    //                                             {
    //                                                 renderButton()
    //                                             }
    //                                         </InlineStack>
    //                                     </BlockStack>
    //                                 </Box>

    //                                 {/* plan carousel */}
    //                                 {tabs?.[selected]?.subcontent}

    //                                 <React.Fragment>
    //                                     {
    //                                         monthlyPlusUserFreePlan?.length !== 0 && monthlyPlusUserFreePlan?.forEach((plan: any, id: number) => {
    //                                             props?.redux?.current?.source?.plan_name == 'shopify_plus' &&
    //                                                 <div className='Custom-Pricing--CustomPlan' style={{ marginTop: '5%' }} key={id}>
    //                                                     <Card roundedAbove='sm'>
    //                                                         <BlockStack inlineAlign='start' align='start' gap="200">
    //                                                             <Text variant="headingLg" as="p" fontWeight='semibold'>
    //                                                                 Free {t("Plan")}
    //                                                             </Text>
    //                                                             <Text as='p' fontWeight='semibold'>{t("Get charged $0/month and manage up to 50 orders every month")}.</Text>
    //                                                             <Text as='p'>{t("Whether you're a new merchant or considering a switch, this plan allows you to experience our platform firsthand at absolutely no cost. With 50 monthly orders, you can explore our features, benefits, and customer support, gaining valuable insights and assessing how our services can enhance your business.")}</Text>
    //                                                             <Button
    //                                                                 size='large'
    //                                                                 onClick={() => {
    //                                                                     setPlusUserLoader(true)
    //                                                                     handlePlanModal(plan)
    //                                                                 }}
    //                                                                 disabled={plan?.title == activePlanName &&
    //                                                                     plan?.plan_id == activePlanID ||
    //                                                                     plan?.active == false}
    //                                                                 loading={plusUserLoader}
    //                                                             >{t("Try For Free")}
    //                                                             </Button>
    //                                                         </BlockStack>
    //                                                     </Card>
    //                                                 </div >
    //                                         })
    //                                     }
    //                                 </React.Fragment>
    //                             </BlockStack>

    //                             {/* FAQ Section */}
    //                             <div style={{ marginTop: '20px' }}>
    //                                 <BlockStack gap="500">
    //                                     <div className='Custom-Spacing'>
    //                                         <BlockStack gap="200">
    //                                             <InlineStack align='space-between' gap="200" blockAlign='center'>
    //                                                 <Text variant="headingLg" as="p" fontWeight='semibold'>{t("Frequently Asked Questions")}</Text>
    //                                                 <Button onClick={() => {
    //                                                     props.di.globalState.set('fromPricingPlan', 'true')
    //                                                     activePlanName !== '' && syncActivated ? appBridgeRouting('faq', props) : props.history('../panel/faq')
    //                                                 }} variant="plain">{t("View all questions")}</Button>
    //                                             </InlineStack>
    //                                             <Divider />
    //                                         </BlockStack>
    //                                     </div>
    //                                     {faq.length > 0 && renderFaq(faq)}
    //                                 </BlockStack>
    //                             </div>
    //                         </BlockStack >



    //                         {/* footer */}
    //                         < FooterHelp >
    //                             <InlineStack align="center" gap='100'>
    //                                 <div><Icon source={CircleInformationMajor} tone="info" /></div>
    //                                 {t("Learn more about")}
    //                                 <Link target='_blank' url="https://docs.cedcommerce.com/shopify/multi-account-amazon-cedcommerce/?section=pricing_plans">
    //                                     {t("CedCommerce Amazon Channel")}
    //                                 </Link>,<Link target='_blank' url='https://amazon-sales-channel-app-backend.cifapps.com/Cedcommerce_Privacy_Statement.pdf'>
    //                                     {t("Terms & Conditions")}
    //                                 </Link>{t("and")}<Link target='_blank' url='https://amazon-sales-channel-app-backend.cifapps.com/Data_Privacy_Rights.pdf'>
    //                                     {t("Data Privacy Rights")}
    //                                 </Link>. {t("Need Help?")}<Link onClick={() => activePlanName == '' || !syncActivated ? props.history('../panel/support', {
    //                                     replace: false,
    //                                     state: {
    //                                         fromPricingPlan: true
    //                                     }
    //                                 }) : props.history('../support')}>
    //                                     {t("Get Support")}
    //                                 </Link > {t("or")} < Link target='_blank' url="https://calendly.com/cedcommerce-awe-sales/sales" >
    //                                     {t("Book a Call")}
    //                                 </Link >
    //                             </InlineStack >
    //                         </FooterHelp >
    //                     </Page >
    //                 </div >
    //         }

    //         {/* FEATURES MODAL */}
    //         <Modal
    //             open={featureModal.open}
    //             title={<Text as='p' fontWeight='semibold'>{t("All pricing features")}</Text>}
    //             onClose={() => setFeatureModal({ open: false, features: [] })}
    //         >
    //             <Modal.Section>
    //                 <BlockStack gap="500">
    //                     {
    //                         featureModal.features?.map((feature: any, ind: number) => {
    //                             return (
    //                                 <InlineStack blockAlign='start' wrap={false} gap="200" key={ind}>
    //                                     <div> {feature?.image && feature?.image !== "" ? <img src={feature?.image} alt="feature-icon" width='36px' height='36px' /> : <img height='10px' width='12px' alt='check' src={pricingCheck} />} </div>
    //                                     <div className='Custom-Stack-Item--fill'>
    //                                         <BlockStack gap="100">
    //                                             <Text as='p'><span dangerouslySetInnerHTML={{ __html: t(feature?.feature?.trim()) }}></span></Text>
    //                                             {feature?.description !== "" ? <Text as='p' tone='subdued'><span dangerouslySetInnerHTML={{ __html: t(feature?.description?.trim()) }}></span></Text> : <></>}
    //                                         </BlockStack>
    //                                     </div>
    //                                 </InlineStack>
    //                             );
    //                         })
    //                     }
    //                 </BlockStack>
    //             </Modal.Section>
    //         </Modal>

    //         {/* Settlement Modal */}
    //         <Modal
    //             open={settlementModal.open}
    //             title={t('Attention!')}
    //             onClose={() => setSettlementModal({ open: false, planId: '', data: {} })}
    //             primaryAction={{
    //                 content: t('Pay Now'),
    //                 onAction: () => settleServices(),
    //                 // disabled: !settlementModal.data?.invoice?.show_pay_now,
    //                 loading: loadPayButton
    //             }}
    //         >
    //             <Modal.Section>
    //                 <BlockStack gap="400">
    //                     <Text as='p' fontWeight='semibold'>
    //                         {t("Kindly pay the Excess Usage Charges to proceed choosing a new plan.")}
    //                     </Text>
    //                     <Divider />
    //                     <InlineStack gap='400' align='space-between' wrap={false}>
    //                         <Text as='p' fontWeight='semibold'>{t("Excess usage charge generated")}</Text>
    //                         <Text as='p' fontWeight='semibold'>{
    //                             Object.values(settlementModal.data)?.length > 0 ?
    //                                 `$${settlementModal.data?.settlement_price}.00 USD` : "$00.00 USD"
    //                         }</Text>
    //                     </InlineStack>
    //                     <InlineStack align='space-between' gap="400" wrap={false}>
    //                         <Text as='p' tone='subdued'>({formatDate(settlementModal?.data?.invoice?.generated_at)} - {formatDate(settlementModal?.data?.invoice?.updated_at)})</Text>
    //                         <Text as='p' tone='subdued'>(${settlementModal?.data?.invoice?.postpaid?.per_unit_usage_price || 0.00}/ {settlementModal?.data?.invoice?.postpaid?.unit_qty > 1 ? settlementModal?.data?.invoice?.postpaid?.unit_qty + ' orders' : settlementModal?.data?.invoice?.postpaid?.unit_qty + ' order'})</Text>
    //                     </InlineStack>
    //                     <Divider />
    //                     <>
    //                         <BlockStack gap="200">
    //                             <InlineStack gap="100">
    //                                 <Text as='p' tone='success' fontWeight='semibold'>{t("LAST DAY TO SETTLE:")} </Text>
    //                                 <Text as='p' tone='success' fontWeight='semibold'>{formatDate(settlementModal.data?.invoice?.last_payment_date)} (12am GMT, 5am IST)</Text>
    //                             </InlineStack>
    //                             <BlockStack gap="100">
    //                                 <Text as='p'>{
    //                                     (activePlanData?.hasOwnProperty('sync_activated') && activePlanData?.sync_activated === true) ?
    //                                         "If you pay excess usage charges with a remaining credit balance, accessing additional credits within the same month will be restricted. Credits will be renewed at the start of the next month."
    //                                         :
    //                                         "Once you pay your excess usage charges, you will immediately gain access to the app. Your plan credits will renew automatically at the beginning of the next month."
    //                                     // "Kindly pay the Excess Usage Charges to ensure continuous order syncing."
    //                                 }</Text>
    //                                 <InlineStack gap="100">
    //                                     <Link removeUnderline onClick={() => activePlanName == '' || !syncActivated ? props.history('../panel/support', { replace: false, state: { fromPricingPlan: true } }) : props.history('../support')}>{t("Contact us")}</Link>
    //                                     <Text as='p'>{t("or read the")}</Text>
    //                                     <Link removeUnderline onClick={() => {
    //                                         if (activePlanName == '' || !syncActivated) {
    //                                             props.di.globalState.set('fromPricingPlan', 'true')
    //                                             props.history('../panel/faq')
    //                                         } else {
    //                                             props.di.globalState.set('fromPricingPlan', 'true')
    //                                             props.history('../faq')
    //                                         }
    //                                     }}>{t("frequently asked questions")}</Link>
    //                                     <Text as='p'>{t("for further assistance.")}</Text>
    //                                 </InlineStack>
    //                             </BlockStack>
    //                         </BlockStack>
    //                     </>
    //                 </BlockStack>
    //             </Modal.Section>
    //         </Modal>

    //         {/* plan modal */}
    //         <Modal
    //             open={planModal?.active}
    //             onClose={() => setPlanModal({ active: false, plan_data: {} })}
    //             title={t("Selected plan details")}
    //             primaryAction={{
    //                 content: t('Confirm and proceed'),
    //                 onAction: () => planModal?.plan_data?.title === 'Free' ? choosePlan(planModal?.plan_data?.plan_id, "Free") : planModal?.plan_data?.title === 'Trial' ? choosePlan(planModal?.plan_data?.plan_id, "Trial") : choosePlan(planModal?.plan_data?.plan_id),
    //                 loading: activeButtonIndex ? yearlyButtonLoading[planModal?.plan_data?.plan_id] : monthlyButtonLoading[planModal?.plan_data?.plan_id]
    //             }}
    //         >
    //             <Modal.Section>
    //                 <BlockStack gap="500">
    //                     <BlockStack gap="300" inlineAlign='center'>
    //                         <CircleTickIcon />
    //                         <Text variant="headingSm" as="h6">{`${t(planModal.plan_data?.title)} `}</Text>
    //                         {
    //                             Object.keys(planModal?.plan_data).length > 0 &&
    //                                 Object.values(planModal?.plan_data?.discounts)?.length > 0 ?
    //                                 <InlineStack gap="200" wrap={false} blockAlign='baseline'>
    //                                     <InlineStack gap="200" wrap={false} blockAlign='baseline'>
    //                                         {
    //                                             planModal?.plan_data?.title !== 'Free' &&
    //                                             <Text variant="headingLg" as="p">
    //                                                 <Text as='span' tone='subdued'>
    //                                                     {/* <s>${Math.ceil(+planModal?.plan_data?.custom_price / 12 ?? 0)}</s> */}
    //                                                     <s>${Math.ceil((+planModal?.plan_data?.custom_price || 0) / 12)}</s>
    //                                                 </Text>
    //                                             </Text>
    //                                         }
    //                                         {
    //                                             planModal?.plan_data?.title !== 'Free' ?
    //                                                 <InlineStack wrap={false} gap="100" blockAlign='start'>
    //                                                     <Text as="h6">
    //                                                         ${
    //                                                             planModal?.plan_data?.discounts?.[0]?.type == 'percentage' ?
    //                                                                 ((planModal?.plan_data?.custom_price - ((planModal?.plan_data?.discounts[0]?.value / 100) * planModal?.plan_data?.custom_price)) / 12).toFixed(2)
    //                                                                 :
    //                                                                 ((planModal?.plan_data?.custom_price - planModal?.plan_data?.discounts[0]?.value) / 12).toFixed(2)
    //                                                         }
    //                                                     </Text>
    //                                                 </InlineStack>
    //                                                 :
    //                                                 <Text as="h6">${(+planModal?.plan_data?.custom_price / 12 || 0).toFixed(2)}</Text>
    //                                         }
    //                                     </InlineStack>
    //                                     <Text as='p' tone='subdued'>/{t("mo")}</Text>
    //                                 </InlineStack>
    //                                 :
    //                                 planModal?.plan_data?.code == 'trial' ? <Text as="h6">{t("50 Orders (One-Time)")}</Text> : <InlineStack wrap={false} gap="100" blockAlign='baseline'>
    //                                     <Text as="h6">${planModal?.plan_data?.custom_price || 0}</Text>
    //                                     <Text as="h6">{planModal?.plan_data?.billed_type == "yearly" ? "/year" : "/month"}</Text>
    //                                 </InlineStack>

    //                         }
    //                         <div style={{ width: '100%' }}>
    //                             <Divider />
    //                         </div>
    //                     </BlockStack>
    //                     <BlockStack gap='400' inlineAlign='start'>
    //                         <Text variant="headingSm" as="h6">
    //                             {`${t("What’s included in")} ${t(planModal.plan_data?.title)}?`}
    //                         </Text>
    //                         <div className="custom__plan-modal">
    //                             <BlockStack gap="200">
    //                                 {
    //                                     expanded ?
    //                                         planModal?.plan_data?.features?.map((feature: any, idx: number) => {
    //                                             return (
    //                                                 <InlineStack blockAlign='center' gap="200" wrap={false} key={idx}>
    //                                                     <Tick />
    //                                                     <Text as='p' tone='subdued'>
    //                                                         <span dangerouslySetInnerHTML={{ __html: t(feature?.feature) }}></span>
    //                                                     </Text>
    //                                                 </InlineStack>
    //                                             )
    //                                         })
    //                                         :
    //                                         planModal?.plan_data?.features?.slice(0, 4)?.map((feature: any, idx: number) => {
    //                                             return (
    //                                                 <InlineStack blockAlign='center' gap="200" wrap={false} key={idx}>
    //                                                     <Tick />
    //                                                     <Text as='p' tone='subdued'>
    //                                                         <span dangerouslySetInnerHTML={{ __html: t(feature?.feature) }}></span>
    //                                                     </Text>
    //                                                 </InlineStack>
    //                                             )
    //                                         })
    //                                 }
    //                             </BlockStack>
    //                         </div>
    //                         <Button
    //                             variant='plain'
    //                             disclosure={expanded ? 'up' : 'down'}
    //                             onClick={() => setExpanded(!expanded)}
    //                         >
    //                             {expanded ? t('Show less') : t('Show more')}
    //                         </Button>
    //                     </BlockStack>

    //                 </BlockStack>
    //             </Modal.Section >
    //         </Modal >

    //         {/*Current plan modal */}
    //         < Modal
    //             open={currentPlanModal?.active}
    //             onClose={() => setCurrentPlanModal({ active: false, plan_data: {} })
    //             }
    //             title={t("Selected plan details")}
    //         >
    //             <Modal.Section>
    //                 <BlockStack gap="500">
    //                     <BlockStack gap="300" inlineAlign='center'>
    //                         <CircleTickIcon />
    //                         <Text variant="headingSm" as="h6">
    //                             {`${currentPlanModal.plan_data?.title} ${t("Plan added successfully!")}`}
    //                         </Text>
    //                         {
    //                             Object.keys(currentPlanModal?.plan_data).length > 0 &&
    //                                 Object.values(currentPlanModal?.plan_data?.discounts)?.length > 0 ?
    //                                 <InlineStack gap="200" wrap={false} blockAlign='baseline'>
    //                                     <InlineStack gap="200" wrap={false} blockAlign='baseline'>
    //                                         {
    //                                             currentPlanModal?.plan_data?.title !== 'Free' &&
    //                                             <Text variant="headingLg" as="p">
    //                                                 <Text as='span' tone='subdued'>
    //                                                     <s>
    //                                                         {/* ${Math.ceil(+currentPlanModal?.plan_data?.custom_price / 12 ?? 0)} */}
    //                                                         ${Math.ceil((+currentPlanModal?.plan_data?.custom_price || 0) / 12)}
    //                                                     </s>
    //                                                 </Text>
    //                                             </Text>
    //                                         }
    //                                         {
    //                                             currentPlanModal?.plan_data?.title !== 'Free' ?
    //                                                 <InlineStack wrap={false} gap="100" blockAlign='start'>
    //                                                     <Text as="h6">
    //                                                         ${
    //                                                             currentPlanModal?.plan_data?.discounts?.[0]?.type == 'percentage' ?
    //                                                                 ((currentPlanModal?.plan_data?.custom_price - ((currentPlanModal?.plan_data?.discounts[0]?.value / 100) * currentPlanModal?.plan_data?.custom_price)) / 12).toFixed(2)
    //                                                                 :
    //                                                                 ((currentPlanModal?.plan_data?.custom_price - currentPlanModal?.plan_data?.discounts[0]?.value) / 12).toFixed(2)
    //                                                         }
    //                                                     </Text>
    //                                                 </InlineStack>
    //                                                 :
    //                                                 <Text as="h6">${(+currentPlanModal?.plan_data?.custom_price / 12 || 0).toFixed(2)}</Text>
    //                                         }
    //                                     </InlineStack>
    //                                     <Text as='p' tone='subdued'>/{t("mo")}</Text>
    //                                 </InlineStack>
    //                                 :
    //                                 <InlineStack wrap={false} gap='100' blockAlign='baseline'>
    //                                     <Text as="h6"> ${currentPlanModal.plan_data?.custom_price || 0} </Text>
    //                                     <Text as="h6">/{t("mo")}</Text>
    //                                 </InlineStack>
    //                         }
    //                         <div style={{ width: '100%' }}>
    //                             <Divider />
    //                         </div>
    //                     </BlockStack>
    //                     <BlockStack gap="400" inlineAlign='start'>
    //                         <Text variant="headingSm" as="h6">{`${t("What’s included in")} ${planModal.plan_data?.title}?`}</Text>
    //                         <div className="custom__plan-modal">
    //                             <BlockStack gap="200">
    //                                 {
    //                                     expanded ?
    //                                         currentPlanModal?.plan_data?.features?.map((feature: any, idx: number) => {
    //                                             return (
    //                                                 <InlineStack blockAlign='center' gap="200" wrap={false} key={idx}>
    //                                                     <Tick />
    //                                                     <Text as='p' tone='subdued'>
    //                                                         <span dangerouslySetInnerHTML={{ __html: t(feature?.feature) }}></span>
    //                                                     </Text>
    //                                                 </InlineStack>
    //                                             )
    //                                         })
    //                                         :
    //                                         currentPlanModal?.plan_data?.features?.slice(0, 4)?.map((feature: any, idx: number) => {
    //                                             return (
    //                                                 <InlineStack blockAlign='center' gap="200" wrap={false} key={idx}>
    //                                                     <Tick />
    //                                                     <Text as='p' tone='subdued'>
    //                                                         <span dangerouslySetInnerHTML={{ __html: t(feature?.feature) }}></span>
    //                                                     </Text>
    //                                                 </InlineStack>
    //                                             )
    //                                         })
    //                                 }
    //                             </BlockStack>
    //                         </div>
    //                         <Button
    //                             variant='plain'
    //                             disclosure={expanded ? 'up' : 'down'}
    //                             onClick={() => setExpanded(!expanded)}
    //                         >
    //                             {expanded ? t('Show less') : t('Show more')}
    //                         </Button>
    //                     </BlockStack>
    //                 </BlockStack >
    //             </Modal.Section >
    //         </Modal >
    //     </div >
    // );
}

export default DI(NewPricingPlan)